import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'ui/acro'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'
import { ClassCard } from 'components_v1/SchemaSectionRenderer/common/components'
import { axios } from '../api'
import usePlaylistDrawer from 'hooks/usePlaylistDrawer'
import { useWindowResize } from 'hooks'
import useAddToCalendar from 'hooks/useAddToCalendar'
import ProgramButtonActions from './programs/ProgramButtonActions'

const ClassCardsContainer = styled(Flex)`
  align-items: center;
  flex-wrap: wrap;
  text-align: left;
`
const Title = styled(Flex)`
  color: ${(props) => props.theme.colors.black};
  text-align: center;
  justify-content: center;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 125% */
  letter-spacing: -0.96px;
  text-transform: uppercase;
  margin-bottom: 32px;
`

const WorkoutsSection = ({ planDetails, user }) => {
  const [classes, setClasses] = useState()
  const { handleAddToCalendarClick, AddToCalendarDialog } = useAddToCalendar()
  const { width } = useWindowResize()
  const isMobile = width <= 480

  const { slug } = planDetails

  const updatePlaylistList = (updatedPlaylistIds) => {
    setClasses((prev) =>
      prev.map((classitem) =>
        classitem.id === selectedCardData?.id
          ? { ...classitem, playlistIds: updatedPlaylistIds }
          : classitem
      )
    )
  }
  const { handlePlaylistIconClick, AddToPlaylistDrawer, selectedCardData } =
    usePlaylistDrawer(updatePlaylistList)

  const fetchData = async () => {
    try {
      const res = await axios.get(`/plan_entries?plan_id=${slug}`)
      if (res.status === 200) {
        setClasses(res?.data)
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ThemeProvider theme={LightTheme}>
      <ProgramButtonActions fetchData={fetchData} />
      <Title id='workouts-section'>Classes </Title>
      {classes && (
        <ClassCardsContainer
          gap={['4%', '2%']}
          pl={['0px', '16px', '105px']}
          pr={['0px', '16px', '105px']}
        >
          {classes.map((classItem, index) => (
            <Box
              width={['48%', '32%', '32%', '32%']}
              mb='16px'
              style={{ alignSelf: 'stretch' }}
              key={classItem.id}
            >
              <ClassCard
                {...classItem}
                showAllMetaData={false}
                cardIndex={index + 1}
                isGridView={isMobile}
                membershipTier={user?.membershipTier}
                onPlaylistIconClick={() => handlePlaylistIconClick(classItem)}
                isFevIcon={Boolean(user) && Boolean(classItem?.video?.id)}
                showScheduleButton={classItem?.unlocked}
                handleAddToCalendarClick={() => {
                  handleAddToCalendarClick(classItem)
                }}
              />
            </Box>
          ))}
        </ClassCardsContainer>
      )}
      {AddToPlaylistDrawer}
      {AddToCalendarDialog}
    </ThemeProvider>
  )
}

export default WorkoutsSection
